document.addEventListener("DOMContentLoaded", function () {
  const sliderList = document.querySelectorAll(".collection-slider-row");
  const spliderList = document.querySelectorAll(".splide-slider");

  if (sliderList) {
    sliderList.forEach((slider) => {
      const sliderControls = slider.querySelector(".slider-controls");
      if (sliderControls) {
        const imageSize = slider.querySelector(".image-cont").offsetHeight / 2;
        const sliderBtnSize =
          slider.querySelector(".slider-nav__btn.next").offsetHeight / 2;
        const setPositionSize = imageSize - sliderBtnSize;
        sliderControls.style = `top: ${setPositionSize}px`;
      }
    });
  }
  if (spliderList) {
    spliderList.forEach((slider) => {
      const sliderControls = slider.querySelector(".slider-controls");
      if (sliderControls) {
        const imageSize =
          slider.querySelector(".splide__slide.is-active .image-cont")
            .offsetHeight / 2;
        const sliderBtnSize =
          slider.querySelector(".slider-nav__btn.next").offsetHeight / 2;
        const setPositionSize = imageSize - sliderBtnSize;
        sliderControls.style = `top: ${setPositionSize}px`;
      }
    });
  }

  window.addEventListener("resize", () => {
    if (sliderList) {
      sliderList.forEach((slider) => {
        const sliderControls = slider.querySelector(".slider-controls");
        if (sliderControls) {
          const imageSize =
            slider.querySelector(".image-cont").offsetHeight / 2;
          const sliderBtnSize =
            slider.querySelector(".slider-nav__btn.next").offsetHeight / 2;
          const setPositionSize = imageSize - sliderBtnSize;
          sliderControls.style = `top: ${setPositionSize}px`;
        }
      });
    }
    if (spliderList) {
      spliderList.forEach((slider) => {
        const sliderControls = slider.querySelector(".slider-controls");
        if (sliderControls) {
          const imageSize =
            slider.querySelector(".splide__slide.is-active .image-cont")
              .offsetHeight / 2;
          const sliderBtnSize =
            slider.querySelector(".slider-nav__btn.next").offsetHeight / 2;
          const setPositionSize = imageSize - sliderBtnSize;
          sliderControls.style = `top: ${setPositionSize}px`;
        }
      });
    }
  });
});
